@if (isVisible) {
  <div
    @slideFromTop
    class="survey-banner"
    role="region"
    [attr.aria-label]="'surveyBannerAriaLabel' | translate"
  >
    <div
      class="survey-banner__icon-section"
      [class.survey-banner__icon-section--informational]="
        messageType === BannerMessageType.Informational
      "
      [class.survey-banner__icon-section--warning]="messageType === BannerMessageType.Warning"
      [class.survey-banner__icon-section--critical]="messageType === BannerMessageType.Critical"
    >
      <img
        class="survey-banner__icon"
        src="assets/icons/ccom-logo-svg/CCOM-Symbol-DarkGrey.svg"
        alt="ccom logo"
      />
    </div>

    <button
      type="button"
      class="survey-banner__message"
      [class.survey-banner__message--disabled]="!customUrl"
      [disabled]="!customUrl"
      (click)="openSurvey()"
    >
      <span>{{ customMessage }}</span>
    </button>

    <div class="survey-banner__close-section">
      <app-ui-button
        buttonType="icon-button"
        icon="close"
        [tooltip]="'close'"
        (click)="dismiss()"
      ></app-ui-button>
    </div>
  </div>
}
